import { render, staticRenderFns } from "./GameVote.vue?vue&type=template&id=5d12c23a&"
import script from "./GameVote.vue?vue&type=script&lang=js&"
export * from "./GameVote.vue?vue&type=script&lang=js&"
import style0 from "./GameVote.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports